import script from "./ShiftSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftSettings.vue?vue&type=script&setup=true&lang=js"

import "./ShiftSettings.vue?vue&type=style&index=0&id=9236b8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9236b8d6"]])

export default __exports__